import type { ModValue } from './types.js';

export const elemModClassName = (blockName: string, elemName: string, modName: string, modValue: ModValue) => {
    if (!modValue && modValue !== 0) return;

    if (modValue === true) {
        return `${blockName}__${elemName}_${modName}`;
    }

    return `${blockName}__${elemName}_${modName}_${modValue}`;
};
